
	/**
	 * @description
	 *  Modelo de una plantilla.
	 *
	 * @see gigot-backend/Models/Print/TemplateModel.cs
	 */

export class TemplateModel {

	;

	/**
	 * @description
	 *	Construye una plantilla con una semántica vacía. Nótese que no es lo
	 *	mismo que construir una plantilla con valores por defecto. Las reglas
	 *	generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Una plantilla vacía.
	 */
	public static empty(): TemplateModel {
		const templateModel: TemplateModel = new TemplateModel();
		return templateModel;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicTemplateModel
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicTemplateModel: TemplateModel): TemplateModel {
		if (!anemicTemplateModel) return undefined;
		const templateModel: TemplateModel = TemplateModel.empty();
		return templateModel;
	}
}
